// src/Components/TopBar/SalaryCalculatorButton.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from 'utils/AuthProvider';
import './SalaryCalculatorButton.css';

const SalaryCalculatorButton = () => {
  const { isClient } = useAuth();
  const [label, setLabel] = useState('$alary Calculator');

  // ✔️ Hook is always called, regardless of isClient
  useEffect(() => {
    if (!isClient) return; // bail out early inside the effect

    const updateButtonLabel = () => {
      setLabel(window.innerWidth <= 768 ? '$alary' : '$alary Calculator');
    };

    updateButtonLabel();
    window.addEventListener('resize', updateButtonLabel);
    return () => {
      window.removeEventListener('resize', updateButtonLabel);
    };
  }, [isClient]); // re-run if isClient changes

  // Only render the link for clients
  if (!isClient) return null;

  return (
    <a
      href="https://accountantsonair.com/salary-calculator"
      className="salary-calculator-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </a>
  );
};

export default SalaryCalculatorButton;
